import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css"
import "../../../assets/css/admin/allAdmins.module.css"
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { Link } from "react-router-dom";
import swal from "sweetalert";


const AllPackages = () => {
  const [admins,setAdmins]=useState([])
  const getPackge=()=>{
    axios.get(`${baseUrl}/package/all`)
    .then(res=>setAdmins(res.data))
    .catch(e=>console.log(e))
  }
  useEffect(()=>{
    getPackge()
  },[])


  const deletePackage=(a)=>{
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        axios.post(`${baseUrl}/package/delete/?id=${a._id}&path=${a.path}`)
          .then(res=>{
            getPackge()
              swal("Package has been deleted!", {
                  icon: "success",
                });
              }
          )
        
      } 
    });
  }

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: "30px" }}></div>
        <hr></hr>
        <div
          className="container"
          style={{ backgroundColor: "white", padding: "40px" }}
        >
                  <h4 className="mb-4"> All Packages</h4>
          <div>
            <table>
              <thead>
                <tr>
                  <td>SI</td>
                  <td>Name</td>
                  <td>Exams</td>
                  <td>Payment Type</td>
                  <td>Amount</td>
                  <td>Status</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {admins.length > 0 &&
                  admins.map((a, i) => (
                    <tr key={i}>
                      <td>{i+1}</td>
                      <td>{a.packageName}</td>
                      <td>{a.examName}</td>
                      <td>{a.paymentType}</td>
                      <td>{a.amount}</td>
                      <td>{a.active?'Active':'Deactive'}</td>
                      <td>
                        <Link to={`/admin/exam/package/edit/${a._id}`}><button className="btn btn-success">Edit</button></Link>&nbsp;
                        <button onClick={()=>deletePackage(a)} className="btn btn-danger">Delete</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllPackages;
